import { z } from 'zod';

import { type AnyZodSchema, type CoreZodSchema } from '@Common/types/zod/utils';

export const createZodJSONString = (validator: CoreZodSchema) =>
  z.string().superRefine((value, ctx) => {
    try {
      const parsedValue = JSON.parse(value);
      const result = z.safeParse(validator, parsedValue);

      if (!result.success) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: result.error.message,
          fatal: true,
        });
      }
    } catch {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'could not parse string to JSON',
        fatal: true,
      });
    }
    return;
  });

export const createZodJSONStringParsed = <Type extends AnyZodSchema>(validator: Type) =>
  z.preprocess((input: unknown): unknown => {
    if (typeof input === 'string') {
      try {
        return JSON.parse(input) as unknown;
      } catch {
        return input; // Let the validator handle the error
      }
    }
    return input;
  }, validator);
